import { useCallback } from 'react';

import { signOut } from '@/redux/auth/actions';

import { useAppDispatch } from './redux';

export function useAuthentication() {
  const dispatch = useAppDispatch();

  const onBackToSignIn = useCallback(() => {
    dispatch(signOut());
  }, [dispatch]);

  return {
    onBackToSignIn,
  };
}
